import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from '../../../services/notification.service';
import { FormularioService } from '../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { Observable } from 'rxjs';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-rs005-card-X',
    templateUrl: './rs005-card-X.component.html'
})

export class Rs005CardXComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    // public filteredConfigRolos: Observable<DropDownListDTO[]>;
    // public filteredTipoCalha: Observable<DropDownListDTO[]>;
    // public listConfigRolos?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    // public listTipoCalha?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    // public listConfigRolosOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    // public listTipoCalhaOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    @Output() objMakeCalculations = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Avaliação de Morte Prematura', false);
          this.formulario = this.formBuilder.group({
            total_espigas_morte_prematura: [null, []],
            morte_prematura_prc: [null, []],
        });
    }

    async ngOnInit(): Promise<void> {
        await this.getLists();
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    public async makeCalculations(): Promise<void> {
        this.objMakeCalculations.emit();
    }

    async getLists(): Promise<void> {
        //await Promise.all([this.getListConfigRolos(), this.getListTipoCalha()]);
    }

}

